import {ApiUrls} from 'shared/config/model/urls';

import {createApi} from '@reduxjs/toolkit/query/react';
import httpBaseQuery from 'shared/api/rtk-query/httpBaseQuery';
import {IZone} from 'entities/location';

export const zoneAPI = createApi({
    reducerPath: 'zoneAPI',
    baseQuery: httpBaseQuery(),
    tagTypes: ['Zone'],
    endpoints: (build) => ({
        getZones: build.query<IZone[], void>({
            query: () => ({
                path: ApiUrls.ZONES,
            }),
            providesTags: ['Zone'],
        }),
    }),
});